export default "__VITE_ASSET__B2q$tcK9__"